{
  "MaxPartitions": "Verranno controllati i dispositivi solo nelle prime {} partizioni, abilitare \"Report a livello di telefonia\" nelle impostazioni Telsys per controllare tutte le partizioni.",
  "NAME": "ErrorLanguage",
  "Error_Title": "Scusa",
  "Error_SubTitle": "Non riusciamo a trovare la pagina che stai cercando.",
  "Error_Message": "La pagina o la risorsa potrebbe essere stata spostata, aggiornata o eliminata. \n \n Oppure potresti aver digitato l'indirizzo web in modo errato. Controlla l'indirizzo e l'ortografia.",
  "Error_PageTitle": "Spiacenti, non riusciamo a trovare la pagina che stai cercando.",
  "Validations_MustBeUnique": "Il valore deve essere univoco"
}